import axios from 'axios';
import store from '../store';
import { attachTokenRefresh } from '@/utils/authInterceptors';
import { notify } from '@/utils/notify';

const baseURL = process.env.VUE_APP_ENV === 'production' 
  ? "https://api.vibrant-wellness.com/v1/ehr/chat" 
  : "https://api.vibrant-wellness.com/v1/ehr/chat-cloudstaging";


const rocketChatService = axios.create({
  baseURL: baseURL,
});

rocketChatService.interceptors.request.use(
  async function(config) {
    // Expiry / refresh / logout is owned by sessionManager (the attachTokenRefresh
    // interceptor runs first and refreshes when needed). Do NOT clear the session
    // here on an expired exp — that also wipes a still-valid refresh token and
    // blocks recovery from a transient (5xx/network) refresh failure.
    const currentToken = store.state.login.token;
    if (currentToken) {
      // Use Bearer token format with original JWT token
      config.headers = {
        ...config.headers,
        'Authorization': `Bearer ${currentToken}`
      };
      
      // Only set Content-Type for non-FormData requests
      // FormData requests need to let the browser set the Content-Type with boundary
      if (!(config.data instanceof FormData)) {
        config.headers['Content-Type'] = 'application/json';
      }
    } 
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

rocketChatService.interceptors.response.use(
  response => {
    const res = response.data;
    if (![200,204,201].includes(response.status)) {
      notify({
        title: "Error",
        message: response.message,
        type: "error",
      });
      return Promise.reject("error");
    }
    else {
      return response;
    }
  },
  error => {
    console.log("err ", error);

    // Handle 401 Unauthorized - token expired or invalid
    if (error.response && error.response.status === 401) {
      console.warn('Authentication token expired or invalid');
      store.dispatch('login/handleAuthError');   

      // Redirect to login page
      // window.location.href = '/my-patients';
    }

    // Skip error notification if _silent flag is set
    if (error.config && error.config._silent) {
      return Promise.reject(error);
    }
   
    if (!error.response) {
      notify({
        title: "Error",
        message: error.message,
        type: "error",
        duration: 8000,
      });
      return Promise.reject(error);
    }
    if (error.response.data && typeof error.response.data === "object") {
      let { message } = error.response.data;
      if (message) {
        notify({
          title: "Error",
          message,
          type: "error",
          duration: 8000
        });
        return Promise.reject(error);
      }
    }
    notify({
      title: "Error",
      message: error.message,
      type: "error",
      duration: 8000,
    });
    return Promise.reject(error);
  }
);


// // Send a message to a channel or DM
// async function sendMessage(roomId, message) {
//   const res = await axiosInstance.post('/chat.postMessage', {
//     roomId,
//     text: message,
//   });
//   return res.data;
// }

// // Get channel list
// async function getRooms() {
//   const res = await axiosInstance.get('/rooms.get');
//   return res.data.update;
// }

attachTokenRefresh(rocketChatService);

export default rocketChatService;
